


































import { Component, Vue } from 'vue-property-decorator';
import { Table } from 'element-ui';
import { requiredOnChange } from '@/shared/validation/rule';
import CreateForm from './components/CreateForm.vue';

@Component({
  name: 'Accessoriess',
  components: {
    CreateForm,
  },
})
export default class Accessoriess extends Vue {
  public listAccessories: any[] = [];

  private isLoading = false;

  private dialogVisible = false;

  private selectedAccessoriesId: number | null = null;

  protected created() {
    this.fetch();
  }

  protected handleCurrentChange(val: any) {
    this.selectedAccessoriesId = val ? val.id : null;
  }

  protected clearSelect() {
    if (this.$refs.accessoriesTable) (this.$refs.accessoriesTable as Table).setCurrentRow(undefined);
  }

  private async fetch() {
    this.clearSelect();
    this.isLoading = true;
    this.listAccessories = await this.$api.accessories.getListAccessories();
    this.isLoading = false;
  }

  private async create(form: any) {
    this.isLoading = true;
    await this.$api.accessories.createAccessories(form);
    this.isLoading = false;
    this.dialogVisible = false;
    this.fetch();
  }
}
